import React, { useRef, useState } from "react";
import classnames from "classnames";
import { PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import styles from "./Transcript.module.scss";

interface Props {
  url: string;
  className?: string;
}

function AudioPlayButton({ url, className }: Props) {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasError, setHasError] = useState(false);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) {
      return;
    }
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play().catch(() => {
        setIsPlaying(false);
        setHasError(true);
      });
    }
  };

  const getTooltip = () => {
    if (hasError) {
      return "Audio unavailable";
    }
    return isPlaying ? "Pause audio" : "Play audio";
  };

  return (
    <>
      <Tooltip title={getTooltip()}>
        <span className={styles.playButtonWrapper}>
          <button
            type="button"
            className={classnames(styles.playButton, className)}
            onClick={toggle}
            disabled={hasError}
          >
            {isPlaying ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
          </button>
        </span>
      </Tooltip>
      <audio
        ref={audioRef}
        src={url}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
        onError={() => {
          setIsPlaying(false);
          setHasError(true);
        }}
      />
    </>
  );
}

export default AudioPlayButton;
